<template>
  <div class="laporan">
    <c-toolbar />
    <c-navbar />
    <v-main>
      <!-- <text>Coba</text> -->
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-card class="mx-auto elevation-5 py-4 px-2">
              <v-row justify="center">
                <v-img
                  src="img/indomaret.png"
                  aspect-ratio="3"
                  max-width="250"
                >
                </v-img>
              </v-row>
              <h3 class="text-center my-4">
                Monitoring Status Pengajuan Bantuan Pendidikan
              </h3>

              <form class="pa-4 mx-3">
                <div class="my-2">
                  <v-row>
                      <v-col class="d-flex" cols="12" sm="3">
                      <v-select
                        :items="items_status"
                        label="Status"
                        v-model="status"
                        item-text="statustransaksi"
                        item-value="statustransaksi"
                        @change="dataUnit"
                      ></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">
                      <v-autocomplete
                        :items="items_unit"
                        label="Unit"
                        v-model="unit"
                        item-text="PT"
                        item-value="ID_PT"
                        return-object
                        @change="dataCabang"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                      <v-col class="d-flex" cols="12" sm="4">
                      <v-autocomplete
                        :items="items_cabang"
                        label="Cabang"
                        v-model="cabang"
                        item-text="CABANG"
                        item-value="ID_CABANG"
                        return-object
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="3">
                      <v-select
                        :items="items_periode"
                        label="Periode"
                        v-model="periode"
                        item-text="periode"
                        item-value="periode"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row> </v-row>
                  <v-row justify="center">
                    <v-col cols="12" sm="2" class="shrink text-end">
                      <v-btn
                        color="primary"
                        block
                        :loading="btnLoading"
                        @click="filterRekap()"
                        v-show="validRekap"
                        >Filter</v-btn
                      >
                    </v-col>
                  </v-row>
                  <div class="mt-10" v-show="dataTable">
                    <template>
                      <v-data-table
                        :headers="headers"
                        :items="itemsTableMonitoring"
                        :search="search"
                        class="elevation-1"
                      >
                        <template v-slot:[`item.JURUSAN`]="{ item }">
                          {{
                            item.JURUSAN == null ||  item.JURUSAN == "" || item.JURUSAN == "null"
                              ? "-"
                              : item.JURUSAN 
                          }}
                        </template>
                        <template v-slot:[`item.PEJABAT`]="{ item }">
                          {{
                            item.PEJABAT == null ||  item.PEJABAT == "" || item.PEJABAT == "null"
                              ? "-"
                              : item.PEJABAT 
                          }}
                        </template>
                        <template v-slot:[`item.KETERANGAN_REJECT`]="{ item }">
                          {{
                            item.KETERANGAN_REJECT == null ||  item.KETERANGAN_REJECT == "" || item.KETERANGAN_REJECT == "null"
                              ? "-"
                              : item.KETERANGAN_REJECT 
                          }}
                        </template>
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-btn
                              color="success"
                              dark
                              class="mb-2"
                              @click="downloadExcel()"
                            >
                              Export Excel
                            </v-btn>

                            <!-- jarak judul -->
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>

                            <!-- search -->
                            <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                      </v-data-table>
                    </template>
                  </div>
                </div>
              </form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
// @ is an alias to /src
// import Sidebar from "@/components/Sidebar.vue";
// import Toolbar from "@/components/Toolbar.vue";
import CNavbar from '../../components/CNavbar.vue'
import CToolbar from '../../components/CToolbar.vue'
import { mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";

export default {
  name: "Home",
  components: {
    CNavbar,
    CToolbar,
  },

  mounted() {
    this.TOKEN = this.token
    this.getDataStatus();
    // this.dataUnit();
    // this.dataStatus();
    // this.userRole = sessionStorage.getItem("role");
    // this.dataBagian();
  },

  computed: {
    ...mapGetters({
      user: "user",
      hasAllAccess: "hasAllAccess",
      token:"token"
      // getDrawer: "drawer",
    }),
    dateRangeText() {
      return this.dates.join(" ~ ");
    },

    computedDateFormatted() {
      // return this.dates.join(' ~ ');
      if (this.dates.length <= 0) {
        return "";
      } else {
        let date1 = this.formatDate(new Date(this.dates[0]));
        let date2 = this.formatDate(new Date(this.dates[1]));

        if (date2 < date1) {
          date2 = this.formatDate(new Date(this.dates[0]));
          date1 = this.formatDate(new Date(this.dates[1]));
        }
        const merge = [date1, date2];
        const temp = merge.join(" ~ ");
        return temp;
      }
    },

    validRekap() {
      // const userRole = sessionStorage.getItem("role");
      return (
        // this.cabang != "" &&
        // this.unit != "" &&
        this.periode != "" 
        // this.status != ""
      );
    },

    // headers() {
    //   //set having unique values
    //   let s = new Set();
    //   var f;

    //   this.itemsTableRekap.forEach((item) => {
    //     for (f in item) {
    //       //adding an existing value doesn't override the old one
    //       s.add(f);
    //     }
    //   });
    //   //respect the headers format required by Vuetify which
    //   // should has at least two fields (text, value)
    //   return Array.from(s).map((a) => {
    //     return {
    //       text: a.toUpperCase(),
    //       value: a,
    //     };
    //   });
    // },
  },

  data: () => ({
    // $baseurl: "http://localhost/",
    // $baseurl: "http://116.204.128.50:80/",
    // $baseurl: "https://ms.hrindomaret.com/",
    userRole: "",
    menu2: false,
    dates: [],
    btnLoading: false,
    dataTable: false,
    unit: "",
    cabang: "",
    periode: "",
    // periode_akhir: "",
    direktorat: "",
    bagian: "",
    status: "",
    statusLemparan:"",
    // departemen: "",
    items_unit: [],
    items_cabang: [],
    items_periode: [],
    items_departemen: [],
    items_direktorat: [],
    items_bagian: [],
    items_status: [],
    search: null,
    headers: [
      { text: "Nomor Tiket", value: "NO_TIKET" },
      { text: "NIK", value: "NIK" },
      { text: "Nama", value: "NAMA_KARYAWAN" },
      { text: "Unit", value: "UNIT_NAME" },
      { text: "Cabang", value: "CABANG_NAME" },
    //   { text: "Direktorat", value: "DIREKTORAT_NAME" },
    //   { text: "Departemen", value: "DEPARTEMEN_NAME" },
      { text: "Bagian", value: "BAGIAN_NAME" },
      { text: "Jabatan", value: "JABATAN" },
      { text: "Job Class", value: "JOBCLASS" },
      { text: "Tingkat Pendidikan", value: "NAMA_TINGKAT_BEASISWA" },
      { text: "Jurusan", value: "JURUSAN" },
      { text: "Status", value: "STATUS_TRANSAKSI_DESCRIPTION" },
      { text: "Penerima Bantuan", value: "PENERIMA_BEASISWA" },
      { text: "NIK Pejabat Approver", value: "PEJABAT"},
      { text: "Keterangan Reject", value: "KETERANGAN_REJECT" },
    ],

    itemsTableMonitoring: [],
    itemsExcel:[]
  }),

  methods: {
    ...mapActions({
            getDataReportBeasiswa:"getDataReportBeasiswa",
            getFilterReportBeasiswa:"getFilterReportBeasiswa",
        }),

        sumField(key) {
        // sum data in give key (property)
        return this.itemsTableRekap.reduce((a, b) => a + (b[key] || 0), 0)
    },

    filterRekap() {
      // let temp_unit = this.unit.map(item => item.ID_PT)
      // // console.log(temp_unit);
      // let isi_unit = ''
      // // let i = 0
      // for (let i= 0; i<temp_unit.length; i++){
      //   isi_unit += '\''+temp_unit[i]+'\','
      // }
      // // // console.log(isi_unit)
      // let final_unit = isi_unit.substr(0, isi_unit.length-1)
      // // console.log(final_unit)

      // console.log(this.unit.ID_PT);
      // console.log(this.cabang.ID_CABANG);
      // console.log(this.periode);
      // // console.log(this.periode_akhir);
      // // console.log(this.dates[1]);
      // this.btnLoading = false;
      // this.dataTable = true;
      // let date1 = this.dates[0];
      // let date2 = this.dates[1];

      //   if (date2 < date1) {
      //     date2 = this.dates[0];
      //     date1 = this.dates[1];
      //   }
      this.btnLoading = true;
      // const userRole = sessionStorage.getItem("role");
      const axios = require("axios");
      const code = {
        // nik: sessionStorage.getItem('nik'),
        // idpt: "IDM",
        // idcabang: "00",
        // periode1: "2018",
        // periode2: "2021",
        // kategori: "Rekapitulasi Penerima"
        nik: this.user.data[0].NikKaryawan,
        idpt: this.unit.ID_PT,
        idcabang: this.cabang.ID_CABANG,
        periode: this.periode,
        status: this.status,
        // periode2: this.periode_akhir,
        kategori: "Monitoring Pengajuan",
      };
      // console.log(code);
      // const varToken = sessionStorage.getItem("token");
      // const headers = {
      //   Authorization: "Bearer" + this.TOKEN,
      //   // NIK: this.user.NikKaryawan,
      // };
      // axios
      //   .post(this.$baseurl + "beasiswa/getDataReportBeasiswa", code, {
      //     headers,
      //   })
      this.getDataReportBeasiswa(code)
        .then((response) => {
          const hasil = response.data;
          // console.log(hasil);
          if (hasil.status == "Token is Expired") {
            this.$swal({
              icon: "info",
              title: "Info!",
              text: "Session Anda Telah Habis",
            }).then(() => {
              sessionStorage.clear();
              this.$router.push({ name: "Login" });
            });
          } else {
            // this.itemsTableRekap = hasil.data;
            if (hasil < 0) {
                this.$swal({
              icon: "info",
              title: "Info!",
              text: "Data Tarikan Kosong",
            }).then(()=>{
                window.location.reload()
            })
            }else{

            this.itemsTableMonitoring = hasil.data;

            this.itemsExcel = this.itemsTableMonitoring.map(item =>{
                return{
                    "No Tiket":item.NO_TIKET,
                    "Nik" : item.NIK,
                    "Nama Karyawan": item.NAMA_KARYAWAN,
                    "Unit":item.UNIT_NAME,
                    "Cabang" : item.CABANG_NAME,
                    "Bagian": item.BAGIAN_NAME,
                    "Jabatan":item.JABATAN,
                    "Jobclass" : item.JOBCLASS,
                    "Tingkat Pendidikan" : item.NAMA_TINGKAT_BEASISWA,
                    "Jurusan": item.JURUSAN == null || item.JURUSAN == "" || item.JURUSAN == "null" ? "-" : item.JURUSAN,
                    "Status": item.STATUS_TRANSAKSI_DESCRIPTION,
                    "Penerima Bantuan":item.PENERIMA_BEASISWA,
                    "NIK Pejabat Approver" :  item.PEJABAT == null || item.PEJABAT == "" || item.PEJABAT == "null" ? "-" : item.PEJABAT,
                    "Keterangan Reject": item.KETERANGAN_REJECT == null || item.KETERANGAN_REJECT == "" || item.KETERANGAN_REJECT == "null" ? "-" : item.KETERANGAN_REJECT,
                }
            })
            // // console.log(hasil);
            this.btnLoading = false;
            this.dataTable = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal({
            icon: "error",
            title: "Maaf!",
            text: "Program Error: "+error,
          });
        });
    },

    formatRp(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    formatDate(val) {
      const MyDate = new Date(val);

      const MyDateString =
        ("0" + MyDate.getDate()).slice(-2) +
        "-" +
        ("0" + (MyDate.getMonth() + 1)).slice(-2) +
        "-" +
        MyDate.getFullYear();
      return MyDateString;
    },

    showDate() {
      this.menu2 = false;
      // console.log(this.dates[0]);
      // console.log(this.dates[1]);
    },

    getDataStatus(){
        const code = {
        nik: this.user.data[0].NikKaryawan,
        idpt: "",
        idcabang: "",
        statustransaksi: "",
      };
      // console.log(code)
      // const axios = require("axios");
      // axios
      //   .post(this.$baseurl + "beasiswa/getFilterReportBeasiswa/Stag", code, {
      //     headers,
      //   })
        this.getFilterReportBeasiswa(code)
        .then((response) => {
          // // console.log(response.data.GetAllUnitResult);
          const hasil = response.data;
          // console.log(hasil);
          this.items_status = hasil.statustransaksi
          this.dataUnit();
        })
        .catch((error) => {
          // console.log(error);
          this.$swal({
            icon: "error",
            title: "Maaf!",
            text: "Unit Tidak Ditemukan",
          });
        });
    },

    dataUnit() {
      // const getUnit = {nik: this.user.NikKaryawan}
      // const varToken = sessionStorage.getItem("token");
      // const headers = {
      //   Authorization: "Bearer" + this.TOKEN,
      //   // NIK: this.user.NikKaryawan,
      // };
      const code = {
        nik: this.user.data[0].NikKaryawan,
        idpt: "",
        idcabang: "",
        statustransaksi: this.status,
      };
      // console.log(code)
      // const axios = require("axios");
      // axios
      //   .post(this.$baseurl + "beasiswa/getFilterReportBeasiswa/Stag", code, {
      //     headers,
      //   })
        this.getFilterReportBeasiswa(code)
        .then((response) => {
          // // console.log(response.data.GetAllUnitResult);
          const hasil = response.data;
          // console.log(hasil);
          this.items_unit = hasil.data;
          this.items_periode = hasil.periode;
          this.dataCabang();
        })
        .catch((error) => {
          // console.log(error);
          this.$swal({
            icon: "error",
            title: "Maaf!",
            text: "Unit Tidak Ditemukan",
          });
        });
    },

    dataCabang() {
      // const getUnit = {nik: this.user.NikKaryawan}
      // const varToken = sessionStorage.getItem("token");
      // const headers = {
      //   Authorization: "Bearer" + this.TOKEN,
      //   // NIK: this.user.NikKaryawan,
      // };
      // // console.log(this.unit.ID_UNITROLE)
      const code = {
        nik: this.user.data[0].NikKaryawan,
        idpt: this.unit.ID_PT,
        statustransaksi: "",
      };
      // const axios = require("axios");
      // axios
      //   .post(this.$baseurl + "beasiswa/getFilterReportBeasiswa", code, {
      //     headers,
      //   })
      this.getFilterReportBeasiswa(code)
        .then((response) => {
          // // console.log(response.data.GetAllUnitResult);
          const hasil = response.data;
          this.items_cabang = hasil.data;
          // console.log(hasil.data);
        })
        .catch((error) => {
          // console.log(error);
          this.$swal({
            icon: "error",
            title: "Maaf!",
            text: "Cabang Tidak Ditemukan",
          });
        });
    },

    // dataDirektorat() {
    //   this.direktorat = "";
    //   this.bagian = "";
    //   this.dataBagian();
    //   const getDirektorat = {
    //     // level: "3",
    //     id_unit: this.unit.AliasUnit,
    //     id_cabang: this.cabang.AREAID,
    //   };
    //   const varToken = sessionStorage.getItem("token");
    //   const headers = {
    //     JWT: varToken,
    //     // NIK: this.user.NikKaryawan,
    //   };
    //   const role = sessionStorage.getItem("role");
    //   const axios = require("axios");

    //   if (role == "ETD") {
    //     axios
    //       .post(
    //         this.$baseurl + "api/v1/GetDirektoratByUnitCabang",
    //         getDirektorat,
    //         { headers }
    //       )
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data;
    //           this.items_direktorat = hasil;
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Direktorat Tidak Ditemukan",
    //         });
    //       });
    //   } else if (role == "PIC HO") {
    //     const getBagianHO = {
    //       code: "7",
    //       data: {
    //         NIK: this.user.NikKaryawan,
    //         ROLE: sessionStorage.getItem("role"),
    //       },
    //     };
    //     axios
    //       .post(this.$baseurl + "api/v1/MasterUser", getBagianHO, {
    //         headers,
    //       })
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data.result;
    //           // // console.log(hasil);
    //           let hasiltest = hasil.map((item) => item.ID_BAGIAN);
    //           // // console.log(hasiltest);
    //           for (var i = 0; i < hasiltest.length; i++) {
    //             hasiltest[i] = hasiltest[i].substring(0, 6);
    //           }
    //           // // console.log(hasiltest);
    //           const getDirektoratHO = {
    //             id_direktorat: ";" + hasiltest + ";",
    //             id_cabang: "00",
    //           };
    //           axios
    //             .post(this.$baseurl + "api/v1/GetDirektorat", getDirektoratHO, {
    //               headers,
    //             })
    //             .then((response) => {
    //               if (response.data.Message) {
    //                 this.$swal({
    //                   icon: "info",
    //                   title: "Info!",
    //                   text: "Session Anda Telah Habis",
    //                 }).then(() => {
    //                   sessionStorage.clear();
    //                   this.$router.push({ name: "Login" });
    //                 });
    //               } else {
    //                 const hasil = response.data;
    //                 // // console.log(hasil)
    //                 this.items_direktorat = hasil;
    //               }
    //             });
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Direktorat Tidak Ditemukan",
    //         });
    //       });
    //   } else {
    //     this.dataBagian();
    //   }
    // },

    // dataBagian() {
    //   this.bagian = "";
    //   const getBagian = {
    //     id: this.direktorat.OMOPERATINGUNITNUMBER,
    //   };
    //   const varToken = sessionStorage.getItem("token");
    //   const headers = {
    //     JWT: varToken,
    //     // NIK: this.user.NikKaryawan,
    //   };
    //   const axios = require("axios");
    //   const role = sessionStorage.getItem("role");

    //   if (role == "ETD"  &&  this.cabang.AREAID == '00') {
    //     axios
    //       .post(
    //         this.$baseurl + "api/v1/GetDepartemenByDirektorat",
    //         // "https://ms.hrindomaret.com/api/v1/DVC/Utility/Company/GetDepartemenByDirektorat",
    //         getBagian,
    //         { headers }
    //       )
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data;
    //           this.items_bagian = hasil;
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Bagian Tidak Ditemukan",
    //         });
    //       });
    //   }
    //   else if(role == "ETD" &&  this.cabang.AREAID != '00'){
    //     const getDeptbyCabang = {
    //     id_unit: this.unit.AliasUnit,
    //     id_cabang: this.cabang.AREAID
    //   };
    //   // console.log(getDeptbyCabang)
    //   axios
    //       .post(
    //         this.$baseurl + "api/v1/GetDepartemenByUnitCabang",
    //         // "https://ms.hrindomaret.com/api/v1/DVC/Utility/Company/GetDepartemenByDirektorat",
    //         getDeptbyCabang,
    //         { headers }
    //       )
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data;
    //           this.items_bagian = hasil;
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Bagian Tidak Ditemukan",
    //         });
    //       });
    //   }
    //   else if (role == "PIC HO") {
    //     const getBagianHO = {
    //       code: "7",
    //       data: {
    //         NIK: this.user.NikKaryawan,
    //         ROLE: role,
    //       },
    //     };
    //     axios
    //       .post(this.$baseurl + "api/v1/MasterUser", getBagianHO, { headers })
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data.result;
    //           let hasiltest = hasil.map((item) => {
    //             return {
    //               OMOPERATINGUNITNUMBER: item.ID_BAGIAN,
    //               NAME: item.BAGIAN,
    //             };
    //           });
    //           this.items_bagian = hasiltest;
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Bagian Tidak Ditemukan",
    //         });
    //       });
    //   } else {
    //     //HR Cabang
    //     const getBagianHR = {
    //       id_unit: this.unit.AliasUnit,
    //       id_cabang: this.cabang.AREAID
    //     };
    //     axios
    //       .post(
    //         this.$baseurl + "api/v1/GetDepartemenByUnitCabang",
    //         getBagianHR,
    //         { headers }
    //       )
    //       .then((response) => {
    //         // // console.log(response.data.GetAllUnitResult);
    //         if (response.data.Message) {
    //           this.$swal({
    //             icon: "info",
    //             title: "Info!",
    //             text: "Session Anda Telah Habis",
    //           }).then(() => {
    //             sessionStorage.clear();
    //             this.$router.push({ name: "Login" });
    //           });
    //         } else {
    //           const hasil = response.data;
    //           this.items_bagian = hasil;
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error);
    //         this.$swal({
    //           icon: "error",
    //           title: "Maaf!",
    //           text: "Bagian Tidak Ditemukan",
    //         });
    //       });
    //   }
    // },

    // dataStatus() {
    //   // const getUnit = {nik: this.user.NikKaryawan}
    //   const varToken = sessionStorage.getItem("token");
    //   const headers = {
    //     JWT: varToken,
    //     // NIK: this.user.NikKaryawan,
    //   };
    //   const getStatus = {
    //     code: "5",
    //   };
    //   const axios = require("axios");
    //   axios
    //     .post(this.$baseurl + "api/v1/MasterStatus", getStatus, { headers })
    //     .then((response) => {
    //       // // console.log(response.data.GetAllUnitResult);
    //       const hasil = response.data.message;
    //       this.items_status = hasil;
    //     })
    //     .catch((error) => {
    //       // console.log(error);
    //       this.$swal({
    //         icon: "error",
    //         title: "Maaf!",
    //         text: "Unit Tidak Ditemukan",
    //       });
    //     });
    // },

    downloadExcel() {
      // var headings = [
      //   [
      //     "Unit/PT",
      //     "Cabang",
      //     "Direktorat",
      //     "Departemen",
      //     "Jumlah Karyawan",
      //     "Jumlah Karyawan Success",
      //     "% Success",
      //     "Jumlah Karyawan Outstanding",
      //     "% Outstanding",
      //     "Jumlah Karyawan Pending",
      //     "% Pending",
      //     "Jumlah Karyawan Failed",
      //     "% Failed",
      //     "Jumlah Karyawan None",
      //     "% None",
      //   ],
      // ];
      const wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(this.itemsExcel, {
        origin: "A2",
        // skipHeader: true,
      });
      // XLSX.utils.sheet_add_aoa(ws, headings); //heading: array of arrays

      XLSX.utils.book_append_sheet(wb, ws);

        XLSX.writeFile(wb, "Monitoring Status Pengajuan Bantuan Pendidikan.xlsx");
      
      
    },
  },
};
</script>
